import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Clock } from "lucide-react";

export default function Upcoming() {
  const { data: products } = useQuery({ queryKey: ["upcoming"], queryFn: async () => (await api.get("/products/upcoming")).data });
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
      <div className="text-center max-w-2xl mx-auto mb-10">
        <span className="inline-flex items-center gap-1.5 eyebrow"><Clock className="w-3.5 h-3.5" /> Coming Soon</span>
        <h1 className="mt-3 text-3xl sm:text-4xl font-extrabold text-navy">Upcoming Products</h1>
        <p className="mt-3 text-slate-500">New business systems, printed planners and hybrid products launching soon. Get notified the moment they go live.</p>
      </div>
      {products?.length ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      ) : (
        <p className="text-center text-slate-500 py-16">No upcoming products right now. Check back soon.</p>
      )}
    </div>
  );
}
